import React from 'react';
const CampanaSinLeer = ({ number, ...rest }) => (
  <svg viewBox="0 0 60 60" {...rest}>
    <path
      d="M36.6 19.1c1.8.8 3.3 2.1 4.3 3.8 1.3 2.1 1.6 4.5 1 6.9l-1.5 5.4c-.5 1.8-.4 3.8.2 5.6l1.2 3.4c.1.3-.2.6-.5.5l-9.1-2.4c-.9 1.1-2.3 1.5-3.7 1.1-1.4-.4-2.4-1.5-2.6-2.9l-9-2.5c-.3-.1-.4-.5-.1-.6l2.8-2.3c1.5-1.2 2.5-2.9 3-4.7L24 25c1.2-4.3 5.4-7.1 9.9-6.6l.5-1.7c.1-.2.3-.3.5-.3l2.1.6c.2.1.3.3.3.5l-.7 1.6zm1.1 21.6c-.6-2.1-.6-4.2 0-6.3l1.5-5.4c.4-1.6.2-3.3-.7-4.7-.9-1.4-2.3-2.5-3.9-2.9-3.4-.9-6.9 1.1-7.8 4.4l-1.4 5.4c-.6 2.1-1.6 3.9-3.2 5.4l15.5 4.1z"
      fill="#fff"
    />
    <circle
      cx="25"
      cy="21"
      r="9"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#00F7F0"
    />
    <text
      x="25"
      y="21"
      fontSize="10pt"
      dy="0.3em"
      textAnchor="middle"
      fill="#fff"
    >
      {number}
    </text>
  </svg>
);

export default CampanaSinLeer;
